(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ylc-mobile-details"] && !Shopify.designMode) return;
  try {
    (() => {
    function setupMobileDetails() {
      const labels = document.querySelector('[data-ylc-mobile-details]');
      const nativeButton = document.querySelector('#AddToCart');
      const description = document.querySelector('.product-description-below');
      const guidance = document.querySelector('.ylc-purchase-guidance');
      if (!labels || !nativeButton || !description || !guidance || labels.dataset.initialized) return;
      labels.dataset.initialized = 'true';
      const media = window.matchMedia('(max-width: 768px)');
      let panel;
      let itemDisclosure;
      let positions = [];
      function remember(node) {
        const marker = document.createElement('span');
        marker.hidden = true;
        node.before(marker);
        positions.push({marker, node});
      }
      function disclosure(label, content) {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = label;
        details.append(summary, content);
        return details;
      }
      function applyLayout() {
        if (media.matches && !panel) {
          remember(description);
          remember(guidance);
          panel = document.createElement('div');
          panel.className = 'ylc-mobile-detail-panel';
          const reminder = document.createElement('p');
          reminder.className = 'ylc-mobile-policy-reminder';
          const coverageLink = document.createElement('a');
          coverageLink.href = '/pages/about-ra';
          const coverageLabel = document.createElement('strong');
          coverageLabel.textContent = labels.dataset.returnLink;
          coverageLink.append(coverageLabel);
          reminder.append(labels.dataset.returnPrefix + ' ', coverageLink, ' ' + labels.dataset.returnSuffix);
          itemDisclosure = disclosure(labels.dataset.itemLabel, guidance);
          nativeButton.form.after(panel);
          panel.append(reminder, itemDisclosure);
          panel.after(description);
        } else if (!media.matches && panel) {
          positions.forEach(({marker, node}) => marker.replaceWith(node));
          positions = [];
          panel.remove();
          panel = null;
          itemDisclosure = null;
        }
      }
      media.addEventListener('change', applyLayout);
      applyLayout();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupMobileDetails);
    else setupMobileDetails();
    document.addEventListener('shopify:section:load', setupMobileDetails);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ylc-sticky-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeStickyPurchase() {
      const bar = document.querySelector('[data-ylc-sticky-purchase]');
      const original = document.querySelector('#AddToCart');
      if (!bar || !original || bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const button = bar.querySelector('[data-ylc-sticky-button]');
      const price = bar.querySelector('[data-ylc-sticky-price]');
      const currentPrice = document.querySelector('#ProductPrice');
      function sync() {
        if (currentPrice) price.textContent = currentPrice.textContent.trim();
      }
      button.addEventListener('click', () => {
        const form = original.form;
        if (!form) return;
        form.scrollIntoView({block: 'start'});
        const target = form.querySelector('.single-option-selector') || original;
        target.focus({preventScroll: true});
      });
      new IntersectionObserver(entries => {
        bar.classList.toggle('is-active', !entries[0].isIntersecting);
      }).observe(original);
      new MutationObserver(sync).observe(original, {attributes: true, childList: true, subtree: true});
      if (currentPrice) new MutationObserver(sync).observe(currentPrice, {childList: true, subtree: true});
      sync();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeStickyPurchase);
    else initializeStickyPurchase();
    document.addEventListener('shopify:section:load', initializeStickyPurchase);
  })();
  } catch(e) { console.error(e); }
})();

})();
